import { AppModule } from 'app/module';
import { loadMapsApi } from 'util/mapsApi';
import { CONSENT_GROUPS, hasConsent, onConsentChange, openConsentSettings } from 'util/consent';
import Template from './template.hbs';
import InfoWindow from './infowindow.hbs';
import './styles.scss';

export class CompanyInteractiveMap extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            consentLink: '.m-companyInteractiveMap__consentLink',
            map: '.m-companyInteractiveMap__map',
        };
    }

    domEvents() {
        if (this.dom.consentLink) {
            this.dom.consentLink.addEventListener('click', () => {
                openConsentSettings();
            });
        }
    }

    getPropsFromDom() {
        return {
            isLazyLoad: !!this.dom.map.getAttribute('data-is-lazy-load'),
            locationArray: this.dom.map.getAttribute('data-locations'),
            eventCategory: this.dom.map.getAttribute('data-event-category'),
        };
    }

    ready() {
        if (this.props.isLazyLoad) {
            this.addViewportObserver();
        } else {
            this.mapInit();
        }
    }

    mapInit() {
        let isInitialized = false;
        const init = async () => {
            if (isInitialized || !this.hasConsent()) {
                return;
            }

            isInitialized = true;
            await loadMapsApi();

            const bounds = new google.maps.LatLngBounds();
            const infoArray = JSON.parse(this.props.locationArray);
            const locations = this.locationsFromJson(infoArray);
            const options = this.setOptions(locations);

            for (let i = 0; i < locations.length; i += 1) {
                bounds.extend(locations[i]);
            }

            const map = new google.maps.Map(this.dom.map, options);

            if (locations.length > 1) {
                map.fitBounds(bounds);
            }

            this.setMarkers(map, locations, infoArray);
        };

        onConsentChange(init);
        init();
    }

    entersViewport() {
        this.mapInit();
    }

    locationsFromJson(locationsArray) {
        const locations = [];

        locationsArray.map((location, index) => {
            const { lat } = location;
            const { lng } = location;

            locations[index] = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
            return locations[index];
        });

        return locations;
    }

    setOptions(locations) {
        const options = {
            center: locations[0],
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom: 15,
            streetViewControl: false,
            mapTypeControl: false,
        };

        if (locations.length === 1) {
            options.zoom = 13;
        }

        return options;
    }

    setMarkers(map, locations, info) {
        this.infoWindows = [];

        for (let i = 0; i < locations.length; i += 1) {
            const marker = new google.maps.Marker({
                position: locations[i],
                map,
                icon: {
                    url: '/assets/images/bsLocationIcon.svg',
                    scaledSize: new google.maps.Size(24, 33),
                },
            });

            const infoWindowObject = new google.maps.InfoWindow({
                content: InfoWindow(info[i]),
            });

            this.infoWindows.push(infoWindowObject);

            marker.addListener('click', () => {
                this.hideAllInfoWindows();
                infoWindowObject.open(map, marker);
            });
        }
    }

    hideAllInfoWindows() {
        this.infoWindows.forEach((infoWindowObject) => {
            infoWindowObject.close();
        });
    }

    hasConsent() {
        return hasConsent(CONSENT_GROUPS.performance);
    }
}
